document.documentElement.classList.remove('no-js');

const liveRegion = document.querySelector('#RallyLiveRegion');
const announce = (message) => {
  if (!liveRegion) return;
  liveRegion.textContent = '';
  window.setTimeout(() => { liveRegion.textContent = message; }, 50);
};

const toggleDrawerState = (open) => {
  document.body.classList.toggle('drawer-open', open);
  const scrim = document.querySelector('[data-drawer-scrim]');
  if (scrim) scrim.hidden = !open;
};

const menu = document.querySelector('[data-mobile-menu]');
const menuToggle = document.querySelector('[data-menu-toggle]');
const closeMenu = () => {
  if (!menu || !menuToggle) return;
  menu.hidden = true;
  menuToggle.setAttribute('aria-expanded', 'false');
  toggleDrawerState(false);
  menuToggle.focus();
};
const openMenu = () => {
  if (!menu || !menuToggle) return;
  menu.hidden = false;
  menuToggle.setAttribute('aria-expanded', 'true');
  toggleDrawerState(true);
  menu.querySelector('button, a')?.focus();
};
menuToggle?.addEventListener('click', openMenu);
document.querySelector('[data-menu-close]')?.addEventListener('click', closeMenu);
document.querySelector('[data-drawer-scrim]')?.addEventListener('click', () => {
  closeMenu();
  closeFilters();
});

const searchPanel = document.querySelector('[data-search-panel]');
const searchToggle = document.querySelector('[data-search-toggle]');
const closeSearch = () => {
  if (!searchPanel || !searchToggle) return;
  searchPanel.hidden = true;
  searchToggle.setAttribute('aria-expanded', 'false');
};
searchToggle?.addEventListener('click', () => {
  if (!searchPanel) return;
  const opening = searchPanel.hidden;
  searchPanel.hidden = !opening;
  searchToggle.setAttribute('aria-expanded', String(opening));
  if (opening) searchPanel.querySelector('input')?.focus();
});
document.querySelector('[data-search-close]')?.addEventListener('click', closeSearch);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  if (menu && !menu.hidden) closeMenu();
  if (searchPanel && !searchPanel.hidden) closeSearch();
  const zoom = document.querySelector('[data-zoom-dialog][open]');
  if (zoom) zoom.close();
});

if ('IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach((element) => revealObserver.observe(element));
} else {
  document.querySelectorAll('.reveal').forEach((element) => element.classList.add('is-visible'));
}

const filterPanel = document.querySelector('[data-filter-panel]');
const filterToggle = document.querySelector('[data-filter-toggle]');
function closeFilters() {
  if (!filterPanel || !filterToggle) return;
  filterPanel.classList.remove('is-open');
  filterToggle.setAttribute('aria-expanded', 'false');
  toggleDrawerState(false);
}
filterToggle?.addEventListener('click', () => {
  if (!filterPanel) return;
  filterPanel.classList.add('is-open');
  filterToggle.setAttribute('aria-expanded', 'true');
  toggleDrawerState(true);
  filterPanel.querySelector('button, input, summary')?.focus();
});
document.querySelector('[data-filter-close]')?.addEventListener('click', closeFilters);
document.querySelector('[data-sort-select]')?.addEventListener('change', (event) => event.target.form?.submit());

document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach((button) => {
  button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    const direction = button.hasAttribute('data-quantity-plus') ? 1 : -1;
    input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + direction);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

document.querySelectorAll('[data-zoom-src]').forEach((button) => {
  button.addEventListener('click', () => {
    const dialog = button.closest('[data-product-gallery]')?.querySelector('[data-zoom-dialog]');
    const image = dialog?.querySelector('[data-zoom-image]');
    if (!dialog || !image) return;
    image.src = button.dataset.zoomSrc;
    image.alt = button.dataset.zoomAlt || '';
    dialog.showModal();
  });
});
document.querySelectorAll('[data-zoom-close]').forEach((button) => button.addEventListener('click', () => button.closest('dialog')?.close()));

const formatMoney = (cents) => {
  const currency = window.Shopify?.currency?.active || 'USD';
  const locale = window.Shopify?.locale || document.documentElement.lang || 'en';
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
};

const productSection = document.querySelector('[data-product-section]');
if (productSection) {
  const labels = {
    add: productSection.dataset.labelAdd,
    sold: productSection.dataset.labelSold,
    unavailable: productSection.dataset.labelUnavailable,
    stock: productSection.dataset.labelStock
  };
  const variants = JSON.parse(productSection.querySelector('[data-product-json]')?.textContent || '[]');
  const form = productSection.querySelector('[data-product-form]');
  const variantId = form?.querySelector('[data-variant-id]');
  const addButton = form?.querySelector('[data-add-to-cart]');
  const addLabel = form?.querySelector('[data-add-label]');
  const price = productSection.querySelector('[data-product-price] .price__current');
  const availability = productSection.querySelector('[data-availability]');
  const sticky = productSection.querySelector('[data-sticky-purchase]');
  const stickyButton = productSection.querySelector('[data-sticky-add]');
  const stickyPrice = productSection.querySelector('[data-sticky-price]');

  const selectedOptions = () => [...form.querySelectorAll('.variant-group')].map((group) => group.querySelector('input:checked')?.value);
  const updateVariant = () => {
    const options = selectedOptions();
    const variant = variants.find((candidate) => candidate.options.every((option, index) => option === options[index]));
    form.querySelectorAll('.variant-group').forEach((group) => {
      const label = group.querySelector('[data-option-label]');
      if (label) label.textContent = group.querySelector('input:checked')?.value || '';
    });
    if (!variant) {
      if (addButton) addButton.disabled = true;
      if (addLabel) addLabel.textContent = labels.unavailable;
      if (availability) availability.lastChild.textContent = ` ${labels.unavailable}`;
      return;
    }
    if (variantId) variantId.value = variant.id;
    const available = Boolean(variant.available);
    if (addButton) addButton.disabled = !available;
    if (addLabel) addLabel.textContent = available ? labels.add : labels.sold;
    if (stickyButton) {
      stickyButton.disabled = !available;
      stickyButton.textContent = available ? labels.add : labels.sold;
    }
    if (price) price.textContent = formatMoney(variant.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    if (availability) availability.lastChild.textContent = available ? ` ${labels.stock}` : ` ${labels.sold}`;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };
  form?.querySelectorAll('.variant-input').forEach((input) => input.addEventListener('change', updateVariant));
  stickyButton?.addEventListener('click', () => addButton?.click());

  if (addButton && sticky && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting;
    }, { threshold: 0 });
    stickyObserver.observe(addButton);
  }
}

const addProduct = async (form) => {
  const submit = form.querySelector('[type="submit"]');
  const message = form.querySelector('[data-product-message]');
  submit?.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Could not add this item.');
    const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
    const cart = await cartResponse.json();
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    const confirmation = `${result.product_title || 'Item'} added to cart.`;
    if (message) message.textContent = confirmation;
    announce(confirmation);
  } catch (error) {
    if (message) message.textContent = error.message;
    announce(error.message);
  } finally {
    submit?.removeAttribute('aria-busy');
  }
};
document.querySelectorAll('[data-product-form], .quick-add').forEach((form) => {
  form.addEventListener('submit', (event) => {
    if (form.hasAttribute('data-product-form') && event.submitter?.name !== 'add') return;
    event.preventDefault();
    addProduct(form);
  });
});

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url) return;
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim()) this.innerHTML = recommendations.innerHTML;
      })
      .catch(() => {});
  }
}
if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
